import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrSpinnerButtonDirectiveModule } from '../../directives';
import { HubRegisterFormComponent } from './hub-register-form.component';

@NgModule({
    imports: [
        CommonModule,
        TrSpinnerButtonDirectiveModule,
    ],
    exports: [ HubRegisterFormComponent ],
    declarations: [ HubRegisterFormComponent ],
})
export class HubRegisterFormModule {}
